export default Object.freeze({
	POST: 100,
	BOOK: 101,
	AUTHOR: 102,
	CONTRIBUTOR: 103,
	STATIC: 104,
	ERROR: 105,
	SEARCHPAGE: 106,
	CATEGORY: 107,
});
  
  